// extracted by mini-css-extract-plugin
export default {"button":"styles_button__QtUQO","buttonActive":"styles_buttonActive__FtWvQ","buttonLeft":"styles_buttonLeft__SDQea","buttonRight":"styles_buttonRight__ETJil"};